<template>
  <div class="page">
    <div class="intro">
      <div class="container">
        <div class="intro-title">强劲实力，成就客户</div>
        <div class="intro-msg">
          <div class="item">
            <img src="@/assets/new/real_time_trade.png" alt="" />
            <span>实时交易</span>
          </div>
          <div class="item">
            <img src="@/assets/new/stores.png" alt="" />
            <span>门店管理</span>
          </div>
          <div class="item">
            <img src="@/assets/new/business_analysis.png" alt="" />
            <span>经营分析</span>
          </div>
        </div>
        <div class="intro-but">
          <el-button type="primary" @click="openModal">免费试用</el-button>
          <el-button type="primary" @click="openModal">立即咨询</el-button>
        </div>
      </div>
    </div>

    <div class="second">
      <div class="container">
        <div class="left">
          <div class="title">
            <span>实时语音播报防漏单</span>
          </div>
          <div class="content">
            <span>手机语音播报到账金额，及时清晰，可按门店、设备、日期等多维度查看交易报表，经营情况一目了然</span>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/new/app_second.png" alt="" />
        </div>
      </div>
    </div>

    <div class="three">
      <div class="container">
        <div class="left">
          <div class="title">
            <span>金融场景建设方案</span>
          </div>
          <div class="introduction">
            <span>根据商户行业特征及资金流向，整合银行金融科技产品优势提供针对性的场景建设服务方案</span>
          </div>
          <div class="three-con">
            <div class="item">
              <img src="@/assets/new/pipelining_inspection.png" alt="" />
              <span>流水监测</span>
            </div>
            <div class="item">
              <img src="@/assets/new/store_control.png" alt="" />
              <span>门店管控</span>
            </div>
            <div class="item">
              <img src="@/assets/new/personnel_management.png" alt="" />
              <span>人员管理</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="four">
      <div class="container">
        <div class="title">
          <span>金融场景建设方案</span>
        </div>
        <div class="introduction">
          <span>根据商户行业特征及资金流向，整合银行金融科技产品优势提供针对性的场景建设服务方案</span>
        </div>
        <div class="four-img">
          <img src="@/assets/new/app_three.png" alt="" />
        </div>
      </div>
    </div>

    <Dialog ref="dialog"></Dialog>
  </div>
</template>

<script>
import Dialog from './dialog';
export default {
  name: 'StoreEarnings',
  components: {
    Dialog,
  },
  data() {
    return {};
  },
  methods: {
    openModal() {
      this.$refs.dialog.openLog();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding-top: 65px;
  width: 100%;
  background-color: #f5f8ff;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 第一屏 */
.intro {
  width: 100%;
  background: url(../assets/new/APP.jpg) no-repeat center;
  background-size: cover;
  padding: 60px 0;
  color: #fff;
  display: flex;
  align-items: center;
}
.intro-title {
  font-size: 28px;
  margin-bottom: 20px;
}
.intro-msg {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 16px;
}
.intro-msg .item {
  display: flex;
  align-items: center;
}
.intro-msg .item img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}
.intro-but {
  margin-top: 30px;
  display: flex;
  gap: 15px;
}
.intro-but button:nth-of-type(1) {
  color: #de1f26;
  background-color: #fff;
  border: 1px solid #de1f26;
}
.intro-but button:nth-of-type(2) {
  color: #fff;
  background-color: #de1f26;
  border: 1px solid #fff;
}

/* 第二屏 */
.second {
  padding: 50px 0;
}
.second .container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.second .left {
  width: 100%;
}
.second .left .title {
  font-size: 24px;
  color: #333;
}
.second .left .content {
  color: #707172;
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.6;
}
.second .right {
  width: 100%;
  text-align: center;
}
.second .right img {
  max-width: 100%;
  height: auto;
}

/* 第三屏 */
.three {
  width: 100%;
  background: url(../assets/new/app_nav.png) no-repeat center;
  background-size: cover;
  padding: 60px 0;
  color: #fff;
}
.three .left {
  width: 100%;
}
.three .title {
  font-size: 24px;
}
.three .introduction {
  margin-top: 30px;
  font-size: 16px;
  line-height: 1.6;
}
.three .three-con {
  margin-top: 40px;
  display: flex;
  justify-content: flex-start;
  gap: 30px;
}
.three .three-con .item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.three .three-con .item img {
  width: 28px;
}
.three .three-con .item span {
  margin-top: 8px;
  font-size: 14px;
}

/* 第四屏 */
.four {
  padding: 50px 0;
  text-align: center;
  color: #333;
}
.four .title {
  font-size: 24px;
}
.four .introduction {
  margin: 20px auto 0;
  font-size: 16px;
  line-height: 1.6;
  max-width: 600px;
}
.four .four-img {
  margin-top: 30px;
}
.four .four-img img {
  max-width: 100%;
  height: auto;
}

/* ====================== PC端 ====================== */
@media (min-width: 768px) {
  .intro {
    height: 500px;
    padding: 0;
  }
  .intro-title {
    font-size: 48px;
  }
  .intro-msg {
    font-size: 20px;
  }
  .intro-but {
    margin-top: 50px;
  }

  .second {
    height: auto;
    padding: 80px 0;
  }
  .second .container {
    flex-direction: row;
    align-items: center;
  }
  .second .left {
    width: 40%;
  }
  .second .left .title {
    font-size: 40px;
  }
  .second .left .content {
    font-size: 20px;
    margin-top: 50px;
  }
  .second .right {
    width: 60%;
    padding-left: 5%;
    text-align: left;
  }

  .three {
    height: 600px;
    padding: 0;
    display: flex;
    align-items: center;
  }
  .three .left {
    width: 40%;
  }
  .three .title {
    font-size: 40px;
    padding-top: 0;
  }
  .three .introduction {
    font-size: 20px;
    padding-top: 50px;
  }
  .three .three-con {
    padding-top: 60px;
    font-size: 16px;
  }

  .four {
    padding: 80px 0;
  }
  .four .title {
    font-size: 40px;
  }
  .four .introduction {
    font-size: 20px;
    padding-top: 30px;
  }
  .four .four-img {
    padding-top: 30px;
  }
}

h3,
h4,
h5,
p {
  margin: 0;
  padding: 0;
}
</style>
